import { FeatureFlags } from './types';

export const testFeatureFlags: FeatureFlags = {};
